'use client';

import { useSyncExternalStore } from 'react';

import { isPromoBadgeExpired } from './utils';

const subscribe = () => () => {};

export function useIsOutdated(date?: string | null) {
  return useSyncExternalStore(
    subscribe,
    () => (date ? isPromoBadgeExpired(date) : false),
    () => false
  );
}
